import { render, staticRenderFns } from "./ProfileMir.vue?vue&type=template&id=45b2d029&scoped=true&"
import script from "./ProfileMir.vue?vue&type=script&lang=js&"
export * from "./ProfileMir.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMir.vue?vue&type=style&index=0&id=45b2d029&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b2d029",
  null
  
)

export default component.exports